<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle :value="isChecked" @input="onToggle" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'load-cookie';

export default {
    name: 'control-cookie-load',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Load Cookie Data',
            isChecked: false,
            message: '* This will load data into input from cookie of the same field name.',
        };
    },

    methods: {
        onToggle(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, isChecked);
            } else {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }

            this.isChecked = isChecked;
        },

        onSelectedElement() {
            const data = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            this.isChecked = !!data;
        },
    },
};
</script>
